import { render, staticRenderFns } from "./StudyProgramsModal.vue?vue&type=template&id=12a1ef66&scoped=true"
import script from "./StudyProgramsModal.vue?vue&type=script&lang=ts"
export * from "./StudyProgramsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a1ef66",
  null
  
)

export default component.exports